
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-trash",
  components: {},
})
export default class IconTrash extends Vue {
  @Prop() public width!: number;
  @Prop() public height!: number;
  @Prop() public color!: string;

  constructor() {
    super();
  }
}
